// extracted by mini-css-extract-plugin
module.exports = {"faq_container":"FAQPage_faq_container__cDl2t","faq_page":"FAQPage_faq_page__3dAl0","title_text":"FAQPage_title_text__Xb6zZ","contact_container":"FAQPage_contact_container__388Bj"};